import CargoCompanyAddressUpdateRequest, {
  CargoCompanyAddressUpdateRequestType,
} from "../../../../api/raily/cargo-company/address/update/cargo-company-address-update.request";
import CargoAddressType from "../../../../types/cargo-address-type";
import CargoCompanyAddressUpdateParams from "./cargo-company-address-update-params";

const createType = (
  type: CargoAddressType,
): CargoCompanyAddressUpdateRequestType => {
  switch (type) {
    case CargoAddressType.HOTEL:
      return CargoCompanyAddressUpdateRequestType.HOTEL;
    case CargoAddressType.MEETING_POINT:
      return CargoCompanyAddressUpdateRequestType.MEETING_POINT;
    case CargoAddressType.STATION:
      return CargoCompanyAddressUpdateRequestType.STATION;
  }
};

const create = (
  params: CargoCompanyAddressUpdateParams,
): CargoCompanyAddressUpdateRequest => {
  return {
    addressUuid: params.addressUuid,
    apartment: params.apartment,
    cargoCompanyUuid: params.cargoCompanyUuid,
    country: params.country,
    description: params.description,
    houseNo: params.houseNo,
    lat: params.lat,
    lon: params.lon,
    street: params.street,
    town: params.town,
    type: createType(params.type),
    zipCode: params.zipCode,
  };
};

const cargoCompanyAddressUpdateParamsFactory = {
  create,
};

export default cargoCompanyAddressUpdateParamsFactory;
